import styled from 'styled-components';

import type {StyledTextProps} from './typings';

import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import breakpoints from '@/theme/constants/breakpoints';
import {bootstrapContainerStyles} from '@/theme/constants/container';
import colors from '@/theme/constants/colors';
import typography from '@/theme/typography';
import pxToRem from '@/theme/helpers/pxToRem';
import {sizePx} from '@/theme/helpers/size';

export const StyledAddToBundleSection = styled.section`
  > * {
    ${bootstrapContainerStyles};
  }
`;

export const StyledAddBothButton = styled(CtaButton)`
  width: 180px;
  display: block;
  text-align: center;
  margin-top: ${sizePx(5)};
`;

export const StyledAddToBundleContainer = styled.div`
  @media only screen and ${breakpoints.device.l} {
    max-width: calc(2 / 3 * 100%);
    margin-right: auto;
  }
`;

export const StyledProductBundleHeader = styled.div`
  h5 {
    ${typography.Art}
  }
  margin-bottom: ${sizePx(10)};
`;

export const StyledProductBundleParagraph = styled.p`
  ${typography.Body1}
`;

export const StyledText = styled.span<StyledTextProps>`
  color: ${({$isRed}) => ($isRed ? colors.red100 : 'inherit')};
  font-weight: ${({$isBold}) => ($isBold ? '700' : 'normal')};
  ${({$isArt}) => ($isArt ? typography.Art : '')}
`;

export const StyledBundleCheckedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: ${sizePx(6)} 0 ${sizePx(5)} 0;
  font-size: ${pxToRem(14)};

  @media only screen and ${breakpoints.device.m} {
    display: none;
  }
`;

export const StyledProductBundleContent = styled.div`
  display: grid;

  > div:first-child {
    @media only screen and ${breakpoints.device.m} {
      padding-right: ${sizePx(8)};
    }
    @media only screen and ${breakpoints.device.l} {
      padding-right: ${sizePx(12)};
    }
  }
  > div:last-child {
    display: flex;
    flex-direction: column;

    @media only screen and ${breakpoints.device.m} {
      padding: 0 ${sizePx(6)};
    }
    @media only screen and ${breakpoints.device.l} {
      padding: 0 ${sizePx(6)} 0 ${sizePx(3)};
    }
  }
  @media only screen and ${breakpoints.device.m} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const StyledProductBundleFooter = styled.div`
  display: none;
  @media only screen and ${breakpoints.device.m} {
    display: block;
  }
`;

export const StyledBundleImagesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content 1fr;
  gap: ${sizePx(4)};
  grid-auto-flow: row;
  overflow: hidden;
  margin-bottom: ${sizePx(10)};

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
  }
`;

export const StyledBundleLink = styled.a`
  position: relative;
  background: black;

  &::before {
    content: '';
    padding-bottom: 100%;
    display: block;
  }

  & > figure {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
  }

  &:focus-visible {
    outline: none;
  }

  &:focus-visible::after {
    content: '';
    outline: none;
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border-color: transparent;
    box-shadow: 0px 0px 0px 2px ${colors.red75}, inset 0px 0px 0px 1px ${colors.white};
  }
`;
